import Modal from "./modal";
import { trans } from "../globalFunctions.js";

export default class InviteStakeholderModal extends Modal {
  constructor() {
    super("invite-stakeholder-modal");
    this.$form = document.getElementById("invite-stakeholder-modal");
    this.$stakeholderName = this.$form.querySelector("[data-name]");
    this.$email = this.$form.querySelector('[name="email"]');
    this.$stakeholder = this.$form.querySelector('[name="stakeholder"]');
    this.$modal = new bootstrap.Modal(this.$form);
    this.cb = null;
  }

  setCallback(cb) {
    this.cb = cb;
  }

  validateAndSendForm() {
    const stakeholderId = this.getInt("stakeholder");
    peque
      .api(
        "stakeholders/invite",
        {
          company: this.getInt("company"),
          stakeholder: stakeholderId,
          email: this.getString("email"),
        },
        "post"
      )
      .then((response) => {
        this.$modal.hide();
        peque.navigation.showSuccess(trans("invite_sent"));

        if (typeof this.cb !== "undefined" && this.cb != null) {
          this.cb();
        }
      })
      .catch((e) => {
        if (e.error === peque.ERROR_DUPLICATED_ENTRY) {
          peque.navigation.showError(
            trans("this_email_already_belongs_to_another_stakeholder")
          );
        }
      });
  }

  showFor(stakeholder) {
    this.$email.value = stakeholder.email ? stakeholder.email : "";
    this.$stakeholderName.innerText = stakeholder.name;
    this.$stakeholder.value = stakeholder.id;
    this.show();
  }

  show() {
    this.$modal.show();
    this.$email.focus();
  }
}
